import React, { useState } from 'react';
import * as Sentry from '@sentry/react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { CentsDataGridServer } from 'components/common/dataGrid/dataGridServer';
import TableSearchBar from 'components/common/search/TableSearchBar';
import { getRecurringOrders } from 'api/admin/orders/getRecurringOrders';

const COLUMNS = [
  { headerName: 'ID', field: 'id', sortable: false, flex: 0 },
  { headerName: 'Customer Name', field: 'customerName', sortable: false, flex: 1 },
  { headerName: 'Store Name', field: 'storeName', sortable: false, flex: 1 },
  { headerName: 'Business Name', field: 'businessName', sortable: false, flex: 1 },
  { headerName: 'Interval', field: 'interval', sortable: false, flex: 1 },
  { headerName: 'Pickup window', field: 'pickupWindow', sortable: false, flex: 1 },
  { headerName: 'Return window', field: 'returnWindow', sortable: false, flex: 1 },
  { headerName: 'Cancelled At', field: 'cancelledAt', sortable: false, flex: 1 },
];

export const RecurringOrdersPage = () => {
  const [searchString, setSearchString] = useState('');
  const [pageNumber, setPageNumber] = useState(0);
  const { data, isLoading } = useQuery(
    ['searchRecurringOrders', { searchString, pageNumber }],
    async () => {
      const { data } = await getRecurringOrders(pageNumber, searchString);
      return {
        recurringOrders: data.recurringOrders,
        recurringOrderCount: data.total,
      };
    },
    {
      onError: (error) => {
        Sentry.captureException(error);
      },
    },
  );
  const { recurringOrders, recurringOrderCount } = data ?? {};

  const handlePageChange = ({ page }) => {
    setPageNumber(page);
  };

  const handleSearch = (searchInput) => {
    if (searchInput.length > 0) {
      if (searchInput !== searchString) {
        setPageNumber(0);
      }
      setSearchString(searchInput);
    } else {
      setPageNumber(0);
      setSearchString('');
    }
  };

  const history = useHistory();
  const handleRowClick = ({ id }) => {
    history.push(`/recurring-orders/${Number(id)}`);
  };

  return (
    <>
      <div className="page-container">
        <h1 className="inventory-orders-header">Recurring Orders</h1>
        <div className="inventory-orders-search-bar">
          <TableSearchBar
            value={searchString}
            placeholder="Find a recurring order"
            onSearch={handleSearch}
          />
        </div>
        <CentsDataGridServer
          tableName="RECURRING_ORDERS"
          columns={COLUMNS}
          data={recurringOrders ?? []}
          rowCount={recurringOrderCount ?? 0}
          pageSize={20}
          page={pageNumber}
          onPageChange={handlePageChange}
          onRowClick={handleRowClick}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};
